document.addEventListener('DOMContentLoaded', function() {
    const memberSearch = document.getElementById('member-search');
    if (!memberSearch) {
        return;
    }

    memberSearch.addEventListener('input', function() {
        var keyword = this.value.trim().toLowerCase();
        var items = document.querySelectorAll('#member-list .member-item');
        items.forEach(function(item) {
            var name = item.getAttribute('data-name').toLowerCase();
            if (name.indexOf(keyword) !== -1) {
                item.style.display = '';
            } else {
                item.style.display = 'none';
            }
        });
    });
});
